<a
    class="group block w-full bg-transparent"
    [hyundaiRouterLink]="link()"
    [queryParams]="queryParams()"
    [trackingElLabel]="headline()"
    [trackingElTarget]="link()"
    [trackingEnabled]="trackingEnabled()"
    [trackingElType]="trackingElType()"
    tracking
>
    <div class="relative">
        <ui-m000-c010-image
            class="block overflow-hidden"
            [classList]="getAspectRatio()"
            [image]="{
                image: image().url,
                desktop: hasAspectRatio() ? { width: 368, height: 207 } : { width: 215, height: 121 },
                tablet: hasAspectRatio() ? { width: 460, height: 258 } : { width: 309, height: 157 },
                mobile: hasAspectRatio() ? { width: 719, height: 404 } : { width: 352, height: 199 },
            }"
            [priority]="isFirstView()"
            [alt]="image().alt ?? ''"
            highRes
            cover
        />
        @if (badge(); as data) {
            <ui-m040-c030-badge class="absolute top-12 left-12" type="blue">{{ data }}</ui-m040-c030-badge>
        }
    </div>
    <div class="flex justify-between gap-12 py-16 text-black" [ngClass]="flushContent() ? 'px-0' : 'px-12'">
        <div class="min-w-0 break-words">
            @let headlineF = headline() | footnotes;
            <span class="text-16 leading-27" [innerHTML]="headlineF()"></span>
            @if (text(); as text) {
                @let textF = text | footnotes;
                <p class="text-14 leading-20" [innerHTML]="textF()"></p>
            }
        </div>

        <i
            class="icon-chevron-right group-hover:animate-bouncing-left text-24 size-24 shrink-0 self-start"
            aria-hidden="true"
        ></i>
    </div>
</a>
